import { Monster } from '../types';

export const MONSTERS: { [id: string]: Monster } = {
    'goblin_scout': {
        id: 'goblin_scout',
        name: 'Goblin Scout',
        stats: { health: 30, mana: 0, attack: 8, defense: 4, agility: 10, intelligence: 2 },
        xpReward: 15,
        goldDrop: 5,
    },
    'goblin_warrior': {
        id: 'goblin_warrior',
        name: 'Goblin Warrior',
        stats: { health: 50, mana: 0, attack: 10, defense: 6, agility: 5, intelligence: 2 },
        xpReward: 25,
        goldDrop: 10,
    },
    'goblin_chief': {
        id: 'goblin_chief',
        name: 'Goblin Chief',
        stats: { health: 100, mana: 10, attack: 14, defense: 8, agility: 7, intelligence: 5 },
        xpReward: 100,
        goldDrop: 50,
    },
    // Level 1-5 Monsters
    'giant_rat': {
        id: 'giant_rat',
        name: 'Giant Rat',
        stats: { health: 25, mana: 0, attack: 6, defense: 2, agility: 12, intelligence: 1 },
        xpReward: 10,
        goldDrop: 3,
    },
    'cave_bat': {
        id: 'cave_bat',
        name: 'Cave Bat',
        stats: { health: 20, mana: 0, attack: 5, defense: 1, agility: 15, intelligence: 1 },
        xpReward: 8,
        goldDrop: 2,
    },
    'dire_wolf': {
        id: 'dire_wolf',
        name: 'Dire Wolf',
        stats: { health: 60, mana: 0, attack: 12, defense: 5, agility: 14, intelligence: 3 },
        xpReward: 30,
        goldDrop: 12,
    },
    'forest_spider': {
        id: 'forest_spider',
        name: 'Forest Spider',
        stats: { health: 40, mana: 0, attack: 9, defense: 3, agility: 11, intelligence: 2 },
        xpReward: 20,
        goldDrop: 8,
    },
    'wild_boar': {
        id: 'wild_boar',
        name: 'Wild Boar',
        stats: { health: 70, mana: 0, attack: 11, defense: 7, agility: 6, intelligence: 2 },
        xpReward: 35,
        goldDrop: 15,
    },
    'kobold_miner': {
        id: 'kobold_miner',
        name: 'Kobold Miner',
        stats: { health: 35, mana: 0, attack: 7, defense: 3, agility: 9, intelligence: 4 },
        xpReward: 18,
        goldDrop: 7,
    },
    'bandit_thug': {
        id: 'bandit_thug',
        name: 'Bandit Thug',
        stats: { health: 55, mana: 0, attack: 10, defense: 5, agility: 8, intelligence: 5 },
        xpReward: 28,
        goldDrop: 20,
    },
    'gnoll_scavenger': {
        id: 'gnoll_scavenger',
        name: 'Gnoll Scavenger',
        stats: { health: 65, mana: 0, attack: 13, defense: 6, agility: 9, intelligence: 4 },
        xpReward: 40,
        goldDrop: 18,
    },
    'skeleton_archer': {
        id: 'skeleton_archer',
        name: 'Skeleton Archer',
        stats: { health: 30, mana: 0, attack: 12, defense: 2, agility: 13, intelligence: 1 },
        xpReward: 22,
        goldDrop: 9,
    },
    'zombie_shambler': {
        id: 'zombie_shambler',
        name: 'Zombie Shambler',
        stats: { health: 80, mana: 0, attack: 9, defense: 4, agility: 3, intelligence: 1 },
        xpReward: 25,
        goldDrop: 5,
    },
    'ghoul': {
        id: 'ghoul',
        name: 'Ghoul',
        stats: { health: 50, mana: 0, attack: 15, defense: 5, agility: 12, intelligence: 6 },
        xpReward: 50,
        goldDrop: 25,
    },
    'cultist_acolyte': {
        id: 'cultist_acolyte',
        name: 'Crimson Dawn Acolyte',
        stats: { health: 80, mana: 40, attack: 15, defense: 8, agility: 10, intelligence: 12 },
        xpReward: 60,
        goldDrop: 30,
    },
    // Level 6-15 Monsters
    'grizzly_bear': {
        id: 'grizzly_bear',
        name: 'Grizzly Bear',
        stats: { health: 150, mana: 0, attack: 25, defense: 15, agility: 10, intelligence: 3 },
        xpReward: 120,
        goldDrop: 40,
    },
    'owlbear': {
        id: 'owlbear',
        name: 'Owlbear',
        stats: { health: 180, mana: 0, attack: 30, defense: 18, agility: 12, intelligence: 4 },
        xpReward: 200,
        goldDrop: 70,
    },
    'basilisk': {
        id: 'basilisk',
        name: 'Basilisk',
        stats: { health: 200, mana: 20, attack: 28, defense: 25, agility: 8, intelligence: 5 },
        xpReward: 250,
        goldDrop: 100,
    },
    'giant_scorpion': {
        id: 'giant_scorpion',
        name: 'Giant Scorpion',
        stats: { health: 130, mana: 0, attack: 35, defense: 22, agility: 15, intelligence: 2 },
        xpReward: 180,
        goldDrop: 60,
    },
    'orc_grunt': {
        id: 'orc_grunt',
        name: 'Orc Grunt',
        stats: { health: 100, mana: 0, attack: 20, defense: 12, agility: 10, intelligence: 6 },
        xpReward: 90,
        goldDrop: 30,
    },
    'ogre_brute': {
        id: 'ogre_brute',
        name: 'Ogre Brute',
        stats: { health: 250, mana: 0, attack: 35, defense: 15, agility: 6, intelligence: 5 },
        xpReward: 220,
        goldDrop: 80,
    },
    'hobgoblin_soldier': {
        id: 'hobgoblin_soldier',
        name: 'Hobgoblin Soldier',
        stats: { health: 120, mana: 0, attack: 22, defense: 18, agility: 12, intelligence: 8 },
        xpReward: 150,
        goldDrop: 55,
    },
    'lizardfolk_warrior': {
        id: 'lizardfolk_warrior',
        name: 'Lizardfolk Warrior',
        stats: { health: 110, mana: 0, attack: 18, defense: 16, agility: 14, intelligence: 7 },
        xpReward: 130,
        goldDrop: 45,
    },
    'wight': {
        id: 'wight',
        name: 'Wight',
        stats: { health: 160, mana: 50, attack: 25, defense: 14, agility: 16, intelligence: 10 },
        xpReward: 210,
        goldDrop: 90,
    },
    'spectre': {
        id: 'spectre',
        name: 'Spectre',
        stats: { health: 120, mana: 80, attack: 30, defense: 10, agility: 20, intelligence: 12 },
        xpReward: 240,
        goldDrop: 110,
    },
    'mummy': {
        id: 'mummy',
        name: 'Mummy',
        stats: { health: 220, mana: 30, attack: 28, defense: 20, agility: 8, intelligence: 8 },
        xpReward: 280,
        goldDrop: 150,
    },
    'lesser_fire_elemental': {
        id: 'lesser_fire_elemental',
        name: 'Lesser Fire Elemental',
        stats: { health: 90, mana: 60, attack: 32, defense: 8, agility: 18, intelligence: 9 },
        xpReward: 160,
        goldDrop: 0,
    },
    'lesser_water_elemental': {
        id: 'lesser_water_elemental',
        name: 'Lesser Water Elemental',
        stats: { health: 140, mana: 60, attack: 22, defense: 15, agility: 14, intelligence: 9 },
        xpReward: 160,
        goldDrop: 0,
    },
    'lesser_earth_elemental': {
        id: 'lesser_earth_elemental',
        name: 'Lesser Earth Elemental',
        stats: { health: 180, mana: 30, attack: 25, defense: 25, agility: 7, intelligence: 9 },
        xpReward: 170,
        goldDrop: 0,
    },
    'harpy': {
        id: 'harpy',
        name: 'Harpy',
        stats: { health: 80, mana: 40, attack: 20, defense: 10, agility: 22, intelligence: 10 },
        xpReward: 140,
        goldDrop: 50,
    },
    'centaur_archer': {
        id: 'centaur_archer',
        name: 'Centaur Archer',
        stats: { health: 130, mana: 20, attack: 28, defense: 12, agility: 18, intelligence: 9 },
        xpReward: 190,
        goldDrop: 65,
    },
    'minotaur': {
        id: 'minotaur',
        name: 'Minotaur',
        stats: { health: 280, mana: 10, attack: 40, defense: 20, agility: 10, intelligence: 6 },
        xpReward: 300,
        goldDrop: 120,
    },
    // Level 16-30 Monsters
    'cultist_champion': {
        id: 'cultist_champion',
        name: 'Crimson Dawn Champion',
        stats: { health: 300, mana: 80, attack: 45, defense: 30, agility: 20, intelligence: 15 },
        xpReward: 450,
        goldDrop: 200,
    },
    'orc_warlord': {
        id: 'orc_warlord',
        name: 'Orc Warlord',
        stats: { health: 400, mana: 50, attack: 50, defense: 35, agility: 15, intelligence: 12 },
        xpReward: 500,
        goldDrop: 200,
    },
    'ogre_mage': {
        id: 'ogre_mage',
        name: 'Ogre Mage',
        stats: { health: 350, mana: 150, attack: 30, defense: 25, agility: 10, intelligence: 18 },
        xpReward: 600,
        goldDrop: 250,
    },
    'troll_berserker': {
        id: 'troll_berserker',
        name: 'Troll Berserker',
        stats: { health: 500, mana: 0, attack: 45, defense: 20, agility: 18, intelligence: 5 },
        xpReward: 700,
        goldDrop: 220,
    },
    'lich_acolyte': {
        id: 'lich_acolyte',
        name: 'Lich Acolyte',
        stats: { health: 300, mana: 250, attack: 20, defense: 30, agility: 15, intelligence: 25 },
        xpReward: 800,
        goldDrop: 400,
    },
    'vampire_spawn': {
        id: 'vampire_spawn',
        name: 'Vampire Spawn',
        stats: { health: 380, mana: 100, attack: 40, defense: 28, agility: 22, intelligence: 16 },
        xpReward: 750,
        goldDrop: 350,
    },
    'wraith': {
        id: 'wraith',
        name: 'Wraith',
        stats: { health: 250, mana: 120, attack: 55, defense: 20, agility: 25, intelligence: 14 },
        xpReward: 900,
        goldDrop: 300,
    },
    'fire_elemental': {
        id: 'fire_elemental',
        name: 'Fire Elemental',
        stats: { health: 320, mana: 150, attack: 60, defense: 25, agility: 24, intelligence: 11 },
        xpReward: 1000,
        goldDrop: 0,
    },
    'water_elemental': {
        id: 'water_elemental',
        name: 'Water Elemental',
        stats: { health: 450, mana: 150, attack: 45, defense: 35, agility: 18, intelligence: 11 },
        xpReward: 1000,
        goldDrop: 0,
    },
    'earth_elemental': {
        id: 'earth_elemental',
        name: 'Earth Elemental',
        stats: { health: 600, mana: 80, attack: 50, defense: 50, agility: 10, intelligence: 11 },
        xpReward: 1100,
        goldDrop: 0,
    },
    'air_elemental': {
        id: 'air_elemental',
        name: 'Air Elemental',
        stats: { health: 300, mana: 120, attack: 40, defense: 20, agility: 30, intelligence: 11 },
        xpReward: 1000,
        goldDrop: 0,
    },
    'young_green_dragon': {
        id: 'young_green_dragon',
        name: 'Young Green Dragon',
        stats: { health: 800, mana: 200, attack: 65, defense: 45, agility: 16, intelligence: 15 },
        xpReward: 1500,
        goldDrop: 800,
    },
    'drake_rider': {
        id: 'drake_rider',
        name: 'Drake Rider',
        stats: { health: 450, mana: 50, attack: 55, defense: 40, agility: 20, intelligence: 13 },
        xpReward: 950,
        goldDrop: 450,
    },
    'wyvern': {
        id: 'wyvern',
        name: 'Wyvern',
        stats: { health: 600, mana: 100, attack: 70, defense: 35, agility: 22, intelligence: 8 },
        xpReward: 1200,
        goldDrop: 500,
    },
    'imp': {
        id: 'imp',
        name: 'Imp',
        stats: { health: 150, mana: 100, attack: 25, defense: 15, agility: 28, intelligence: 14 },
        xpReward: 450,
        goldDrop: 180,
    },
    'succubus': {
        id: 'succubus',
        name: 'Succubus',
        stats: { health: 350, mana: 200, attack: 35, defense: 25, agility: 26, intelligence: 19 },
        xpReward: 1100,
        goldDrop: 600,
    },
    'horned_devil': {
        id: 'horned_devil',
        name: 'Horned Devil',
        stats: { health: 700, mana: 150, attack: 75, defense: 55, agility: 18, intelligence: 16 },
        xpReward: 1800,
        goldDrop: 900,
    },
    'hill_giant': {
        id: 'hill_giant',
        name: 'Hill Giant',
        stats: { health: 1000, mana: 0, attack: 80, defense: 40, agility: 8, intelligence: 6 },
        xpReward: 2000,
        goldDrop: 700,
    },
    'frost_giant': {
        id: 'frost_giant',
        name: 'Frost Giant',
        stats: { health: 1500, mana: 100, attack: 90, defense: 60, agility: 12, intelligence: 10 },
        xpReward: 2500,
        goldDrop: 1200,
    },
    'high_priest_malak': {
        id: 'high_priest_malak',
        name: 'High Priest Malak',
        stats: { health: 2500, mana: 1000, attack: 80, defense: 60, agility: 40, intelligence: 100 },
        xpReward: 2000,
        goldDrop: 1000,
    },
    // Level 31+ Monsters
    'chimera': {
        id: 'chimera',
        name: 'Chimera',
        stats: { health: 2000, mana: 300, attack: 100, defense: 70, agility: 18, intelligence: 9 },
        xpReward: 3000,
        goldDrop: 1500,
    },
    'hydra': {
        id: 'hydra',
        name: 'Hydra',
        stats: { health: 2500, mana: 0, attack: 85, defense: 60, agility: 15, intelligence: 7 },
        xpReward: 3500,
        goldDrop: 1800,
    },
    'fire_giant': {
        id: 'fire_giant',
        name: 'Fire Giant',
        stats: { health: 2200, mana: 150, attack: 110, defense: 80, agility: 10, intelligence: 12 },
        xpReward: 4000,
        goldDrop: 2000,
    },
    'iron_golem': {
        id: 'iron_golem',
        name: 'Iron Golem',
        stats: { health: 3000, mana: 50, attack: 120, defense: 150, agility: 8, intelligence: 5 },
        xpReward: 5000,
        goldDrop: 500,
    },
    // Missing monsters for higher level dungeons
    'gorgon': {
        id: 'gorgon',
        name: 'Gorgon',
        stats: { health: 800, mana: 100, attack: 60, defense: 45, agility: 12, intelligence: 15 },
        xpReward: 1400,
        goldDrop: 700,
    },
    'vampire_lord': {
        id: 'vampire_lord',
        name: 'Vampire Lord',
        stats: { health: 1200, mana: 300, attack: 80, defense: 50, agility: 25, intelligence: 20 },
        xpReward: 2000,
        goldDrop: 1000,
    },
    'dragon_whelp': {
        id: 'dragon_whelp',
        name: 'Dragon Whelp',
        stats: { health: 600, mana: 150, attack: 50, defense: 35, agility: 18, intelligence: 12 },
        xpReward: 1200,
        goldDrop: 600,
    },
    'young_dragon': {
        id: 'young_dragon',
        name: 'Young Dragon',
        stats: { health: 1500, mana: 400, attack: 90, defense: 60, agility: 20, intelligence: 18 },
        xpReward: 2500,
        goldDrop: 1500,
    },
    'lich_minion': {
        id: 'lich_minion',
        name: 'Lich Minion',
        stats: { health: 400, mana: 200, attack: 35, defense: 25, agility: 10, intelligence: 30 },
        xpReward: 800,
        goldDrop: 400,
    },
    'lich': {
        id: 'lich',
        name: 'Lich',
        stats: { health: 1000, mana: 800, attack: 50, defense: 40, agility: 15, intelligence: 50 },
        xpReward: 3000,
        goldDrop: 2000,
    },
    'demon_imp': {
        id: 'demon_imp',
        name: 'Demon Imp',
        stats: { health: 300, mana: 150, attack: 40, defense: 20, agility: 25, intelligence: 15 },
        xpReward: 600,
        goldDrop: 300,
    },
    'demon_hound': {
        id: 'demon_hound',
        name: 'Demon Hound',
        stats: { health: 500, mana: 50, attack: 60, defense: 30, agility: 30, intelligence: 8 },
        xpReward: 900,
        goldDrop: 450,
    },
    'demon_brute': {
        id: 'demon_brute',
        name: 'Demon Brute',
        stats: { health: 800, mana: 100, attack: 80, defense: 50, agility: 15, intelligence: 10 },
        xpReward: 1300,
        goldDrop: 650,
    },
    'demon_lord': {
        id: 'demon_lord',
        name: 'Demon Lord',
        stats: { health: 2000, mana: 500, attack: 120, defense: 80, agility: 25, intelligence: 25 },
        xpReward: 4000,
        goldDrop: 2500,
    },
    'ancient_construct': {
        id: 'ancient_construct',
        name: 'Ancient Construct',
        stats: { health: 1200, mana: 0, attack: 70, defense: 100, agility: 5, intelligence: 3 },
        xpReward: 1800,
        goldDrop: 200,
    },
    'stone_golem': {
        id: 'stone_golem',
        name: 'Stone Golem',
        stats: { health: 1500, mana: 0, attack: 80, defense: 120, agility: 3, intelligence: 2 },
        xpReward: 2200,
        goldDrop: 300,
    },
    'ancient_guardian': {
        id: 'ancient_guardian',
        name: 'Ancient Guardian',
        stats: { health: 2500, mana: 200, attack: 100, defense: 150, agility: 8, intelligence: 15 },
        xpReward: 3500,
        goldDrop: 1000,
    },
    'celestial_watcher': {
        id: 'celestial_watcher',
        name: 'Celestial Watcher',
        stats: { health: 800, mana: 300, attack: 60, defense: 40, agility: 20, intelligence: 30 },
        xpReward: 1500,
        goldDrop: 800,
    },
    'celestial_guardian': {
        id: 'celestial_guardian',
        name: 'Celestial Guardian',
        stats: { health: 1200, mana: 400, attack: 80, defense: 60, agility: 25, intelligence: 35 },
        xpReward: 2200,
        goldDrop: 1200,
    },
    'celestial_champion': {
        id: 'celestial_champion',
        name: 'Celestial Champion',
        stats: { health: 1500, mana: 500, attack: 100, defense: 80, agility: 30, intelligence: 40 },
        xpReward: 2800,
        goldDrop: 1500,
    },
    'celestial_avatar': {
        id: 'celestial_avatar',
        name: 'Celestial Avatar',
        stats: { health: 3000, mana: 1000, attack: 150, defense: 120, agility: 40, intelligence: 60 },
        xpReward: 5000,
        goldDrop: 3000,
    },
    'void_spawn': {
        id: 'void_spawn',
        name: 'Void Spawn',
        stats: { health: 600, mana: 200, attack: 70, defense: 30, agility: 35, intelligence: 20 },
        xpReward: 1200,
        goldDrop: 600,
    },
    'void_fiend': {
        id: 'void_fiend',
        name: 'Void Fiend',
        stats: { health: 1000, mana: 300, attack: 90, defense: 50, agility: 40, intelligence: 25 },
        xpReward: 1800,
        goldDrop: 900,
    },
    'void_abomination': {
        id: 'void_abomination',
        name: 'Void Abomination',
        stats: { health: 1500, mana: 400, attack: 110, defense: 70, agility: 20, intelligence: 30 },
        xpReward: 2500,
        goldDrop: 1200,
    },
    'void_lord': {
        id: 'void_lord',
        name: 'Void Lord',
        stats: { health: 3500, mana: 800, attack: 160, defense: 100, agility: 50, intelligence: 50 },
        xpReward: 6000,
        goldDrop: 3500,
    },
    'shadow_wraith': {
        id: 'shadow_wraith',
        name: 'Shadow Wraith',
        stats: { health: 800, mana: 250, attack: 80, defense: 40, agility: 45, intelligence: 25 },
        xpReward: 1600,
        goldDrop: 800,
    },
    'nightmare': {
        id: 'nightmare',
        name: 'Nightmare',
        stats: { health: 1200, mana: 300, attack: 100, defense: 60, agility: 50, intelligence: 30 },
        xpReward: 2200,
        goldDrop: 1100,
    },
    'shadow_assassin': {
        id: 'shadow_assassin',
        name: 'Shadow Assassin',
        stats: { health: 600, mana: 150, attack: 120, defense: 30, agility: 60, intelligence: 20 },
        xpReward: 1800,
        goldDrop: 900,
    },
    'shadow_king': {
        id: 'shadow_king',
        name: 'Shadow King',
        stats: { health: 2800, mana: 600, attack: 140, defense: 80, agility: 70, intelligence: 40 },
        xpReward: 5500,
        goldDrop: 3000,
    },
    'mind_flayer': {
        id: 'mind_flayer',
        name: 'Mind Flayer',
        stats: { health: 1000, mana: 500, attack: 60, defense: 40, agility: 25, intelligence: 80 },
        xpReward: 2500,
        goldDrop: 1500,
    },
    'beholder': {
        id: 'beholder',
        name: 'Beholder',
        stats: { health: 1500, mana: 800, attack: 90, defense: 60, agility: 15, intelligence: 90 },
        xpReward: 3500,
        goldDrop: 2000,
    },
    'aberrant_horror': {
        id: 'aberrant_horror',
        name: 'Aberrant Horror',
        stats: { health: 2000, mana: 400, attack: 120, defense: 80, agility: 30, intelligence: 60 },
        xpReward: 4000,
        goldDrop: 2500,
    },
    'cosmic_entity': {
        id: 'cosmic_entity',
        name: 'Cosmic Entity',
        stats: { health: 5000, mana: 2000, attack: 180, defense: 120, agility: 40, intelligence: 150 },
        xpReward: 8000,
        goldDrop: 5000,
    },
    'arch_devil': {
        id: 'arch_devil',
        name: 'Arch Devil',
        stats: { health: 2500, mana: 600, attack: 150, defense: 100, agility: 35, intelligence: 50 },
        xpReward: 5000,
        goldDrop: 3000,
    },
    'pit_fiend': {
        id: 'pit_fiend',
        name: 'Pit Fiend',
        stats: { health: 3000, mana: 400, attack: 170, defense: 120, agility: 25, intelligence: 40 },
        xpReward: 6000,
        goldDrop: 3500,
    },
    'demon_titan': {
        id: 'demon_titan',
        name: 'Demon Titan',
        stats: { health: 4000, mana: 800, attack: 200, defense: 150, agility: 20, intelligence: 60 },
        xpReward: 7000,
        goldDrop: 4000,
    },
    'satan': {
        id: 'satan',
        name: 'Satan',
        stats: { health: 8000, mana: 2000, attack: 250, defense: 200, agility: 50, intelligence: 100 },
        xpReward: 12000,
        goldDrop: 8000,
    },
    'archangel': {
        id: 'archangel',
        name: 'Archangel',
        stats: { health: 3000, mana: 1000, attack: 120, defense: 100, agility: 40, intelligence: 80 },
        xpReward: 6000,
        goldDrop: 4000,
    },
    'seraph': {
        id: 'seraph',
        name: 'Seraph',
        stats: { health: 2500, mana: 1200, attack: 100, defense: 80, agility: 50, intelligence: 100 },
        xpReward: 5500,
        goldDrop: 3500,
    },
    'deity_fragment': {
        id: 'deity_fragment',
        name: 'Deity Fragment',
        stats: { health: 4000, mana: 1500, attack: 150, defense: 120, agility: 60, intelligence: 120 },
        xpReward: 7500,
        goldDrop: 5000,
    },
    'supreme_deity': {
        id: 'supreme_deity',
        name: 'Supreme Deity',
        stats: { health: 10000, mana: 3000, attack: 300, defense: 250, agility: 80, intelligence: 200 },
        xpReward: 15000,
        goldDrop: 10000,
    },
};

export const RAID_BOSSES: { [id: string]: Monster } = {
    'firelord_razorvane': {
        id: 'firelord_razorvane',
        name: 'Fire Lord Razorvane',
        isRaidBoss: true,
        stats: { health: 5000, mana: 1000, attack: 150, defense: 80, agility: 50, intelligence: 100 },
        xpReward: 10000,
        goldDrop: 2500,
    },
    'koralon_the_frost_lich': {
        id: 'koralon_the_frost_lich',
        name: 'Koralon the Frost Lich',
        isRaidBoss: true,
        stats: { health: 7000, mana: 5000, attack: 200, defense: 120, agility: 80, intelligence: 250 },
        xpReward: 15000,
        goldDrop: 5000,
    },
    'terragor_the_stone_titan': {
        id: 'terragor_the_stone_titan',
        name: 'Terragor the Stone Titan',
        isRaidBoss: true,
        stats: { health: 15000, mana: 500, attack: 250, defense: 300, agility: 30, intelligence: 40 },
        xpReward: 20000,
        goldDrop: 7000,
    },
    'aetherion_sky_tyrant': {
        id: 'aetherion_sky_tyrant',
        name: 'Aetherion, Sky Tyrant',
        isRaidBoss: true,
        stats: { health: 6000, mana: 1500, attack: 220, defense: 100, agility: 280, intelligence: 120 },
        xpReward: 18000,
        goldDrop: 6000,
    },
    'malakor_abyssal_horror': {
        id: 'malakor_abyssal_horror',
        name: 'Malakor, Abyssal Horror',
        isRaidBoss: true,
        stats: { health: 9000, mana: 3000, attack: 240, defense: 180, agility: 150, intelligence: 180 },
        xpReward: 22000,
        goldDrop: 8000,
    },
    'lumina_celestial_sentinel': {
        id: 'lumina_celestial_sentinel',
        name: 'Lumina, Celestial Sentinel',
        isRaidBoss: true,
        stats: { health: 8000, mana: 4000, attack: 210, defense: 220, agility: 160, intelligence: 220 },
        xpReward: 25000,
        goldDrop: 10000,
    },
    'sylvanus_grove_warden': {
        id: 'sylvanus_grove_warden',
        name: 'Sylvanus, Grove Warden',
        isRaidBoss: true,
        stats: { health: 12000, mana: 2000, attack: 180, defense: 250, agility: 90, intelligence: 150 },
        xpReward: 17000,
        goldDrop: 6500,
    },
    'vexor_the_dread_king': {
        id: 'vexor_the_dread_king',
        name: 'Vexor the Dread King',
        isRaidBoss: true,
        stats: { health: 8500, mana: 6000, attack: 230, defense: 150, agility: 140, intelligence: 300 },
        xpReward: 28000,
        goldDrop: 12000,
    },
    'automaton_prime': {
        id: 'automaton_prime',
        name: 'Automaton Prime',
        isRaidBoss: true,
        stats: { health: 10000, mana: 0, attack: 280, defense: 400, agility: 50, intelligence: 20 },
        xpReward: 26000,
        goldDrop: 4000,
    },
    'naga_empress_ssylth': {
        id: 'naga_empress_ssylth',
        name: 'Naga Empress Ssylth',
        isRaidBoss: true,
        stats: { health: 7500, mana: 2500, attack: 260, defense: 130, agility: 260, intelligence: 170 },
        xpReward: 23000,
        goldDrop: 9000,
    },
    'chronos_the_timeless': {
        id: 'chronos_the_timeless',
        name: 'Chronos the Timeless',
        isRaidBoss: true,
        stats: { health: 9999, mana: 9999, attack: 250, defense: 250, agility: 250, intelligence: 250 },
        xpReward: 35000,
        goldDrop: 15000,
    },
    'solaraq_dune_sovereign': {
        id: 'solaraq_dune_sovereign',
        name: 'Solaraq, Dune Sovereign',
        isRaidBoss: true,
        stats: { health: 8000, mana: 1000, attack: 270, defense: 160, agility: 240, intelligence: 110 },
        xpReward: 24000,
        goldDrop: 8500,
    },
    'grommash_the_void_maw': {
        id: 'grommash_the_void_maw',
        name: 'Grommash the Void Maw',
        isRaidBoss: true,
        stats: { health: 13000, mana: 500, attack: 300, defense: 180, agility: 100, intelligence: 80 },
        xpReward: 30000,
        goldDrop: 11000,
    },
    'ignis_magma_behemoth': {
        id: 'ignis_magma_behemoth',
        name: 'Ignis, Magma Behemoth',
        isRaidBoss: true,
        stats: { health: 11000, mana: 800, attack: 290, defense: 220, agility: 60, intelligence: 90 },
        xpReward: 27000,
        goldDrop: 9500,
    },
    'myconid_overmind': {
        id: 'myconid_overmind',
        name: 'Mycelial Overmind',
        isRaidBoss: true,
        stats: { health: 9000, mana: 7000, attack: 180, defense: 180, agility: 80, intelligence: 320 },
        xpReward: 29000,
        goldDrop: 10500,
    },
    'olphia_the_fallen_goddess': {
        id: 'olphia_the_fallen_goddess',
        name: 'Olphia, the Fallen Goddess',
        isRaidBoss: true,
        stats: { health: 50000, mana: 20000, attack: 350, defense: 250, agility: 200, intelligence: 400 },
        xpReward: 50000,
        goldDrop: 25000,
    },
};

export const ALL_MONSTERS: { [id: string]: Monster } = { ...MONSTERS, ...RAID_BOSSES };
